import { useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import AuthStepHeader from "../../components/Auth/AuthStepHeader";
import { Button, ChoiceGroup } from "../../components/design";

/**
 * First guarantor step: add their documents yourself, or email them a request.
 * onBack goes to the profile page, onContinue gets "provide" or "send".
 */
export default function GuarantorChoiceStep({ onBack, onContinue }) {
  const { _t } = useTranslator();
  const [choice, setChoice] = useState("provide");

  return (
    <main className="guarantorPage">
      <div className="guarantorPage__col">
        <AuthStepHeader
          onBack={onBack}
          title={_t("wouldYouLikeToProvideGuarantorDocuments")}
          subtitle={_t("guarantorChooseSub")}
        />
        <ChoiceGroup
          name="guarantor-choice"
          layout="list"
          value={choice}
          onChange={(e) => setChoice(e.target.value)}
          options={[
            {
              value: "provide",
              label: _t("provideGuarantorDocments"),
              description: _t("guarantorProvideDocsDesc"),
            },
            {
              value: "send",
              label: _t("sendRequestToProvideDocuments"),
              description: _t("guarantorSendRequestDesc"),
            },
          ]}
        />
        <Button
          variant="primary"
          size="lg"
          block
          className="guarantorPage__next"
          onClick={() => onContinue(choice)}
        >
          {_t("continue")}
        </Button>
      </div>
    </main>
  );
}
